/* Search modal logic — extracted from snippets/search-modal.liquid. */
(function() {
  const modal = document.querySelector('.js-search-modal');
  const input = document.querySelector('.js-search-input');
  const resultsContainer = document.querySelector('.js-search-products');
  const loadingEl = document.querySelector('.js-search-loading');
  const noResultsEl = document.querySelector('.js-search-no-results');

  if (!modal || !input) return;

  let debounceTimer;
  let currentQuery = '';
  let searchTrackTimer; // debounce for logging the settled search term

  // Debounced search
  input.addEventListener('input', function() {
    const query = this.value.trim();

    clearTimeout(debounceTimer);

    if (query.length < 2) {
      resultsContainer.innerHTML = '';
      loadingEl.style.display = 'none';
      noResultsEl.style.display = 'none';
      return;
    }

    loadingEl.style.display = 'flex';
    noResultsEl.style.display = 'none';
    resultsContainer.innerHTML = '';

    debounceTimer = setTimeout(() => {
      performSearch(query);
    }, 300);
  });

  async function performSearch(query) {
    currentQuery = query;

    try {
      // Use Shopify's predictive search API
      const response = await fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=8&resources[options][fields]=title,product_type,tag,variants.title`);
      const data = await response.json();

      // Check if query changed while fetching
      if (query !== currentQuery) return;

      loadingEl.style.display = 'none';

      const products = data.resources?.results?.products || [];

      // Log what the visitor actually searched — debounced so we capture the
      // settled query (including no-result searches), not one row per keystroke.
      clearTimeout(searchTrackTimer);
      const _term = query, _count = products.length;
      searchTrackTimer = setTimeout(function () {
        if (typeof MburTracker !== 'undefined' && MburTracker.trackCustomEvent) {
          MburTracker.trackCustomEvent('search_query', { search_term: _term, result_count: _count });
        }
      }, 1200);

      if (products.length === 0) {
        resultsContainer.innerHTML = '';
        noResultsEl.style.display = 'block';
        return;
      }

      noResultsEl.style.display = 'none';
      renderResults(products, query);

    } catch (error) {
      console.error('Search error:', error);
      loadingEl.style.display = 'none';
      noResultsEl.style.display = 'block';
    }
  }

  function highlightText(text, query) {
    if (!text || !query) return text || '';
    const regex = new RegExp(`(${query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`, 'gi');
    return text.replace(regex, '<span class="search-modal__highlight">$1</span>');
  }

  function renderResults(products, query) {
    const productsHtml = products.map(product => {
      const image = product.featured_image?.url || product.image || '';
      const title = highlightText(product.title, query);

      // Format the price - Shopify suggest API returns price as a string like "$24.00"
      // or as cents integer, handle both cases
      let price = '';
      if (product.price) {
        if (typeof product.price === 'string' && product.price.includes('$')) {
          price = product.price;
        } else if (typeof product.price === 'number') {
          // Price is in cents
          price = '$' + (product.price / 100).toFixed(2);
        } else {
          // Try parsing as float (could be "24.00" without $)
          const parsed = parseFloat(product.price);
          if (!isNaN(parsed)) {
            if (parsed < 100) {
              // Likely already in dollars
              price = '$' + parsed.toFixed(2);
            } else {
              // Likely in cents
              price = '$' + (parsed / 100).toFixed(2);
            }
          }
        }
      }

      return `
        <a href="${product.url}" class="search-modal__product">
          <div class="search-modal__product-image">
            ${image ? `<img src="${image.replace(/(\.[^.]+)$/, '_128x128$1')}" alt="${escapeHtml(product.title)}" loading="lazy">` : ''}
          </div>
          <div class="search-modal__product-info">
            <h4 class="search-modal__product-title">${title}</h4>
            <span class="search-modal__product-price">${price}</span>
          </div>
        </a>
      `;
    }).join('');

    // Add "View all results" link
    const viewAllHtml = `
      <a href="/search?q=${encodeURIComponent(query)}&type=product" class="search-modal__view-all">
        View all results
      </a>
    `;

    resultsContainer.innerHTML = productsHtml + viewAllHtml;

    // Add click handlers to close modal when product is clicked
    resultsContainer.querySelectorAll('a').forEach(link => {
      link.addEventListener('click', function() {
        closeModal();
      });
    });
  }

  function escapeHtml(text) {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }

  function closeModal() {
    modal.classList.remove('is-open');
    document.body.classList.remove('no-scroll');
    input.value = '';
    resultsContainer.innerHTML = '';
    loadingEl.style.display = 'none';
    noResultsEl.style.display = 'none';
  }

  // Close button handlers - only for explicit close buttons, not product links
  document.querySelectorAll('.search-modal__close, .search-modal__overlay').forEach(btn => {
    btn.addEventListener('click', closeModal);
  });

  // Close on escape
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) {
      closeModal();
    }
  });

  // Submit form on enter
  input.closest('form')?.addEventListener('submit', function(e) {
    if (input.value.trim().length < 2) {
      e.preventDefault();
    } else {
      closeModal();
    }
  });
})();
